export default function setBrandsCarousel() {
  const brandsContainer = document.querySelector('[data-swiper-brands]');

  if (!brandsContainer || brandsContainer.dataset.marqueeInitialized === 'true') return;

  const swiperElement = brandsContainer.querySelector('.swiper');
  const swiperWrapper = brandsContainer.querySelector('.swiper-wrapper');

  if (!swiperElement || !swiperWrapper) return;

  const originalMarkup = swiperWrapper.innerHTML.trim();

  if (!originalMarkup) return;

  const prepareImages = (scope) => {
    scope.querySelectorAll('img').forEach((image) => {
      const dataSrc = image.getAttribute('data-src');
      const dataSrcSet = image.getAttribute('data-srcset');

      if (dataSrc && !image.getAttribute('src')) {
        image.setAttribute('src', dataSrc);
      }

      if (dataSrcSet && !image.getAttribute('srcset')) {
        image.setAttribute('srcset', dataSrcSet);
      }

      image.removeAttribute('loading');
      image.classList.remove('lazy');
    });
  };

  const buildMarquee = () => {
    swiperWrapper.innerHTML = originalMarkup;
    prepareImages(swiperWrapper);

    const minimumTrackWidth = swiperElement.offsetWidth * 1.5;
    let safetyCounter = 0;

    while (swiperWrapper.scrollWidth < minimumTrackWidth && safetyCounter < 8) {
      swiperWrapper.insertAdjacentHTML('beforeend', originalMarkup);
      prepareImages(swiperWrapper);
      safetyCounter += 1;
    }

    const sequenceMarkup = swiperWrapper.innerHTML;
    const sequenceWidth = swiperWrapper.scrollWidth;

    swiperWrapper.insertAdjacentHTML('beforeend', sequenceMarkup);
    prepareImages(swiperWrapper);

    brandsContainer.style.setProperty('--brands-marquee-distance', `-${sequenceWidth}px`);
    brandsContainer.style.setProperty('--brands-marquee-duration', `${Math.max(32, Math.round(sequenceWidth / 50))}s`);
    brandsContainer.classList.add('-marquee-ready');

    if (window.lazyLoad && typeof window.lazyLoad.update === 'function') {
      window.lazyLoad.update();
    }
  };

  let resizeTimer;

  const rebuildOnResize = () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(buildMarquee, 150);
  };

  brandsContainer.dataset.marqueeInitialized = 'true';

  requestAnimationFrame(buildMarquee);
  window.addEventListener('load', buildMarquee, { once: true });
  window.addEventListener('resize', rebuildOnResize);
}